import { createStyles } from 'antd-style';

export const useStationCoreStyles = createStyles(({ token, css }) => {
  return {
    item: css({
      position: 'relative',
      padding: token.paddingSM,
      borderBottom: `1px solid ${token.colorBorderSecondary}`,
      '&:last-child': { marginBottom: 0, borderBottom: 0 },
    }),
    itemNo: css({
      position: 'absolute',
      right: 10,
      top: 15,
      color: 'rgba(0, 0, 0, 0.1)',
      fontSize: 40,
      fontStyle: 'italic',
      zIndex: 0,
      pointerEvents: 'none',
    }),
  };
});

export const useStatinoStyles = createStyles(({ token, css, cx }) => {
  const center = cx(
    css({
      flex: '1 0 auto',
      position: 'relative',
    })
  );
  return {
    center,
    container: css`
      background: ${token.colorBgContainer};
      flex-shrink: 0;
      display: flex;
      flex-direction: column;
      flex: 1;
    `,
    head: css({
      textAlign: 'center',
      padding: '7px 0',
      borderBottom: `1px dashed ${token.colorBorderSecondary}`,
      position: 'relative',
      marginBottom: '0',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }),
    headCenter: css({ flex: '1' }),
    headActions: css({ marginLeft: 'auto', justifySelf: 'flex-end', paddingRight: '10px' }),

    pos: css({
      [`.${center}`]: {
        overflow: 'auto',
        height: 1,
      },
    }),
  };
});
